import { WhatsAppGlyph } from "./BrandIcons";
import { useSettings } from "../lib/settings";

export function WhatsAppButton({ vehicleName = null }) {
  const CONTACT = useSettings();
  const text = vehicleName
    ? `Merhaba, ${vehicleName} aracı için teklif istiyorum.`
    : "Merhaba, kurumsal filo kiralama için bilgi almak istiyorum.";
  const url = `${CONTACT.whatsapp}?text=${encodeURIComponent(text)}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-button"
      aria-label="WhatsApp ile iletişim"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg shadow-[#25D366]/30 hover:scale-110 transition-transform"
    >
      <WhatsAppGlyph className="w-8 h-8" />
    </a>
  );
}
